/**
 * Iter102: Bulk-Aktion Toast mit "Rückgängig"-Button (10s Timer).
 *
 * Verwendung:
 *   import { showBulkActionToast } from "@/lib/bulkActionToast";
 *   showBulkActionToast({
 *     message: "5 gelöscht · 1 übersprungen",
 *     undoToken: r.data.undo_token,
 *     companyId,
 *     onUndo: () => reloadList(),
 *   });
 */
import { toast } from "sonner";
import { apiClient } from "@/lib/apiClient";

export function showBulkActionToast({
  message,
  undoToken,
  companyId,
  onUndo,
  duration = 10000,
}) {
  if (!undoToken) {
    toast.success(message);
    return;
  }
  toast.success(message, {
    duration,
    action: {
      label: "Rückgängig",
      onClick: async () => {
        try {
          const r = await apiClient.post(
            `/companies/${companyId}/bulk-undo/${undoToken}`
          );
          const { restored, action } = r.data;
          toast.success(
            action === "delete"
              ? `${restored} wiederhergestellt`
              : `${restored} Status zurückgesetzt`
          );
          if (onUndo) onUndo();
        } catch (e) {
          const detail = e?.response?.data?.detail || "Undo fehlgeschlagen";
          toast.error(detail);
        }
      },
    },
  });
}
